// src/components/TeamSection.js
import React from "react";
import "./TeamSection.css";
import VetProfileCard from "./VetProfileCard";

// Your image imports and vets array are fine, no changes needed there.
import Jyoti from "../assets/Dr. Jyoti Prakash Kanungo.png";
import Suhan from "../assets/Dr. Suhan H M.png";
import Ajit from "../assets/Dr. Ajit Chikkam.png";
import Anusha from "../assets/Dr. Anusha M.png";
import Harshit from "../assets/Dr. Harshit B H.png";
import Rituraj from "../assets/Dr. Rituraj Kewat.png";
import Tejaswa from "../assets/Dr. Tejaswa Bhargava.png";
import Abhishek from "../assets/Dr. Abhishek S .png";
import Narsimha from "../assets/Dr. Narsimhamurthy NV.png";
// import Khushveer from "../assets/Dr. Rituraj Kewat.png";
// import Revathi from "../assets/Dr. Rituraj Kewat.png";
// import Jyoshna from "../assets/Dr. Jyoti Prakash Kanungo.png";

const vets = [
  {
    image: Jyoti,
    name: "Dr. Jyoti Prakash Kanungo",
    rating: "5",
    experience: "12 YEARS",
    specialty: "Emergency Response, Cardiology, Dermatology, Internal Medicine",
  },
  {
    image: Ajit,
    name: "Dr. Ajit Chikkam",
    rating: "4.9",
    experience: "6 YEARS",
    specialty: "Gynacology, Surgery, Dermatology, Internal Medicine",
  },
  {
    image: Anusha,
    name: "Dr. Anusha M",
    rating: "5",
    experience: "5 YEARS",
    specialty: "Dermatology, Internal Medicine, Emergency Care, Puppy Care",
  },
  {
    image: Harshit,
    name: "Dr. Harshit B H",
    rating: "5",
    experience: "6 YEARS",
    specialty:
      "Surgeon, Dermatology, Emergency Response, Critical Care, Internal Medicine",
  },
  {
    image: Rituraj,
    name: "Dr. Rituraj Kewat",
    rating: "4.9",
    experience: "8 YEARS",
    specialty: "Dermatology, Internal Medicine, Puppy Care",
  },
  {
    image: Tejaswa,
    name: "Dr. Tejaswa Bhargava",
    rating: "4.9",
    experience: "2 YEARS",
    specialty: "General Veterinarian, Puppy care, Dermatology",
  },
  {
    image: Abhishek,
    name: "Dr. Abhishek S",
    rating: "4.9",
    experience: "1 YEARS",
    specialty: "General Veterinarian, Puppy care, Dermatology",
  },
  {
    image: Narsimha,
    name: "Dr. Narsimha Murthy NV",
    rating: "4.8",
    experience: "8 YEARS",
    specialty: "Critical Care, Surgeon, General Veterinarian",
  },
  {
    image: Suhan,
    name: "Dr. Suhan H M",
    rating: "5",
    experience: "3 YEARS",
    specialty:
      "Surgeon & Eye specialist, Cardiology, Gynacology, Gold Medalist",
  }
  // {
  //   image: Khushveer,
  //   name: "Dr. Khushveer Singh",
  //   rating: "4.8",
  //   experience: "2 YEARS",
  //   specialty: "General Veterinarian, Puppy care, Dermatology",
  // },
  // {
  //   image: Revathi,
  //   name: "Dr Revathi",
  //   rating: "4.9",
  //   experience: "3 YEARS",
  //   specialty: "Advanced Daignostics, Critical Care, Eemergency Response",
  // },
  // {
  //   image: Jyoshna,
  //   name: "Dr. Jyoshna",
  //   rating: "4.8",
  //   experience: "1 YEARS",
  //   specialty: "General Veterinarian, Puppy care, Dermatology",
  // },
];

const TeamSection = () => {
  return (
    <section className="team-section">
      {/* <div className="">
        <h2 className="team-section-title">MEET OUR EXPERT VETERINARY TEAM</h2>
      </div> */}

      {/* FIX: Rename classes to be unique */}
      <div className="team-carousel-viewport">
        <div className="team-carousel-track">
          {vets.map((vet, index) => (
            <div className="team-carousel-slide" key={index}>
              <VetProfileCard {...vet} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
